import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    const placeholder = this.element.dataset.placeholder;
    const searchPlaceholder = this.element.dataset.searchPlaceholder;
    const select = $(this.element);

    select.select2({
      width: "100%",
      placeholder: placeholder || "",
      theme: "novem",
      allowClear: false,
      minimumResultsForSearch: 10
    });

    select.on("select2:open", function() {
      $("input.select2-search__field").attr("placeholder", searchPlaceholder);
    });
  }
}
